export default __webpack_public_path__ + "static/media/fileUpoloadVector.169ad14d.png";